import React from 'react'
import EmailVerificationEnvelopeIllustration from './EmailVerificationEnvelopeIllustration'
import EmailVerificationButtonLabel from './EmailVerificationButtonLabel'

const EmailVerificationPrimaryOffer = (props) => {
  const {
    email, onSendCode, onDifferentEmail, onRemindLater, sendCodeLoading,
    errorMessage,
  } = props

  return (
    <div className='emailVerificationFlow-primaryOffer'>
      <EmailVerificationEnvelopeIllustration />
      <div className='emailVerificationFlow-title'>Please verify your email address</div>
      <div className='emailVerificationFlow-description'>
        A verified email address makes it easier to regain access to Plickers if you forget your password.
      </div>
      <div className='emailVerificationFlow-emailBox'>
        <div className='emailVerificationFlow-emailBox-label'>Email address</div>
        <div className='emailVerificationFlow-emailDisplay'>{email}</div>
      </div>
      {errorMessage && (
        <div className='emailVerificationFlow-error'>{errorMessage}</div>
      )}
      <button
        type='button'
        className='btn btn--blue btn--large'
        onClick={onSendCode}
        disabled={sendCodeLoading}
      >
        <EmailVerificationButtonLabel label='Verify' loading={sendCodeLoading} />
      </button>
      <div className='emailVerificationFlow-primaryOffer-links'>
        <button type='button' className='emailVerificationFlow-linkBtn' onClick={onDifferentEmail}>
          I use a different email address now
        </button>
        <button
          type='button'
          className='emailVerificationFlow-linkBtn'
          onClick={onRemindLater}
        >
          Remind me later
        </button>
      </div>
    </div>
  )
}

export default EmailVerificationPrimaryOffer
